import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
// import Login from './views/Login/index.vue'
import { Message } from 'element-ui'
Vue.use(Router)

import Layout from '@/layout/main.vue'
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      path: '/leyeLogin',
      name: 'login',
      meta: {
        name: 'viewport', 
        content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no'
      },
      component: () => import('@/views/Login/index.vue'),
    },{
      path: '/xlpLogin',
      name: 'xlplogin',
      meta: {
        name: 'viewport', 
        content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no'
      },
      component: () => import('@/views/Login/xlpindex.vue'),
    },{
      path: '/xieyi',
      name: 'xieyi',
      meta: {
        name: 'xieyi', 
        
        content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no'
      },
      component: () => import('@/views/Login/xieyi.vue'),
    },{
      path: '/business/task',
      name: 'Bussiness',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/business/task',
          name: 'Task',
          component: () => import('@/views/business/task/index'),
          meta: { title: '服务订单', icon: 'table',keepAlive:true}
        },{
          path: '/business/bill',
          name: 'Bill',
          component: () => import('@/views/business/bill/index'),
          meta: { title: '账单管理', icon: 'table',keepAlive:true }
        },{
          path: '/business/account',
          name: 'Account',
          component: () => import('@/views/business/account/index'),
          meta: { title: '结算管理', icon: 'table' } 
        },{
          path: '/business/neiBuSettlement',
          name: 'neiBuSettlement',
          component: () => import('@/views/business/neiBuSettlement/index'),
          meta: { title: '内部结算账单', icon: 'table' } 
        }, 
        {
          path: '/business/acceptlist',
          name: 'Acceptlist',
          component: () => import('@/views/business/acceptlist/index'),
          meta: { title: '验收单', icon: 'table',keepAlive:true}
        },

        {
          path: '/business/payBill',
          name: 'Acceptlist',
          component: () => import('@/views/business/payBill/index'),
          meta: { title: '支付单', icon: 'table'}
        },
        {
          path: '/business/payBillBatch',
          name: 'Acceptlist',
          component: () => import('@/views/business/payBillBatch/index'),
          meta: { title: '支付单批次', icon: 'table'}
        },
        {
          path: '/business/payMonitor',
          name: 'payMonitor',
          component: () => import('@/views/business/payMonitor/index'),
          meta: { title: '支付监测', icon: 'table'}
        },
        {
          path: '/business/downsizingApplication',
          name: 'Application',
          component: () => import('@/views/business/downsizingApplication/index'),
          meta: { title: '减员保障申请', icon: 'table' }
        }, 
        {
          path: '/business/application',
          name: 'Application',
          component: () => import('@/views/business/application/index'),
          meta: { title: '保障申请', icon: 'table' }
        }, 
        {
          path: '/business/rtapplication',
          name: 'RTApplication',
          component: () => import('@/views/business/RTApplication/index'),
          meta: { title: '日保障申请', icon: 'table' }
        }, 
        {
          path: '/business/order',
          name: 'Order',
          component: () => import('@/views/business/order/index'),
          meta: { title: '保障订单', icon: 'table' }
        }, 
        {
          path: '/business/newAccount',
          name: 'newAccount',
          component: () => import('@/views/business/newAccount/index'),
          meta: { title: '结算管理', icon: 'table' }
        },
        {
          path: '/business/payBillReceipt',
          name: 'AcceptlistReceipt',
          component: () => import('@/views/business/payBillReceipt/index'),
          meta: { title: '电子回单', icon: 'table'}
        },
        {
          path: '/business/newAccountCom',
          name: 'newAccount',
          component: () => import('@/views/business/newAccountCom/index'),
          meta: { title: '结算管理', icon: 'table' }
        }, 
        {
          path: '/business/reckoning',
          name: 'Reckoning',
          component: () => import('@/views/business/reckoning/index'),
          meta: { title: '保障账单', icon: 'table' }
        },
        {
          path: '/business/RTreckoning',
          name: 'Rtreckoning',
          component: () => import('@/views/business/RTreckoning/index'),
          meta: { title: '日投保障账单', icon: 'table' }
        },
        {
          path: '/business/insurancelist',
          name: 'Insurancelist',
          component: () => import('@/views/business/insurancelist/index'),
          meta: { title: '投保清单', icon: 'table' }
        },
        {
          path: '/business/rtOrder',
          name: 'rtOrder',
          component: () => import('@/views/business/RTOrder/index'),
          meta: { title: '日保障订单', icon: 'table' }
        },
        {
          path: '/business/rtInsurancelist',
          name: 'rtInsurancelist',
          component: () => import('@/views/business/RTInsurancelist/index'),
          meta: { title: '日保障清单', icon: 'table' }
        },
        {
          path: '/business/insurancelistTotal',
          name: 'InsurancelistTotal',
          component: () => import('@/views/business/insurancelistTotal/index'),
          meta: { title: '投保清单汇总', icon: 'table' }
        },
        {
          path: '/business/statisticList',
          name: 'statisticList',
          component: () => import('@/views/business/statisticList'),
          meta: { title: '数据统计', icon: 'table' }
        }
        ,
        {
          path: '/business/enterpriseAccountSystem',
          name: 'enterpriseAccountSystem',
          component: () => import('@/views/business/enterpriseAccountSystem'),
          meta: { title: '企业账户体系', icon: 'table' }
        },
        {
          path: '/business/enterpriseBalanceAccount',
          name: 'enterpriseBalanceAccount',
          component: () => import('@/views/business/enterpriseBalanceAccount'),
          meta: { title: '企业余额账户', icon: 'table' }
        }
      ]
    },
    {//组建团队
      path: '/building/team',
      name: 'Building',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/curriculum/vitae',
          name: 'Vitae',
          component: () => import('@/views/building/curriculum/vitae'),
          meta: { title: '个人简历', icon: 'table' }
        },
        {
          path: '/business/task',
          name: 'Task',
          component: () => import('@/views/business/task/index'),
          meta: { title: '服务订单', icon: 'table' }
        },
        {
          path: '/building/team',
          name: 'Team',
          component: () => import('@/views/building/team/index'),
          meta: { title: '组建团队', icon: 'table' }
        },
        {
          path: '/building/jointeam',
          name: 'Jointeam',
          component: () => import('@/views/building/jointeam/index'),
          meta: { title: '加入团队', icon: 'table' }
        },
        {
          path: '/building/hadteam',
          name: 'Hadteam',
          component: () => import('@/views/building/hadteam/index'),
          meta: { title: '已有团队', icon: 'table' }
        }
      ]
    },
    {//消息管理
      path: '/teamnews/todolist',
      name: 'Todolist',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/teamnews/todolist',
          name: 'Todolist',
          component: () => import('@/views/teamnews/todolist/index'),
          meta: { title: '待办事项', icon: 'table' }
        }
      ]
    },
    {//消息管理
      path: '/matching/personJobfit',
      name: 'personJobfit',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/matching/personJobfit',
          name: 'personJobfit',
          component: () => import('@/views/matching/personJobfit/index'),
          meta: { title: '人岗匹配管理', icon: 'table',keepAlive:true }
        },
        {
          path: '/matching/jobExefit',
          name: 'jobExefit',
          component: () => import('@/views/matching/jobExefit/index'),
          meta: { title: '企业匹配管理', icon: 'table',keepAlive:true }
        }
      ]
    },
    {//活动管理
      path: '/activitySys/activityList',
      name: 'activityList',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/activitySys/activityList',
          name: 'activityList',
          component: () => import('@/views/activitySys/activityList/index'),
          meta: { title: '活动管理', icon: 'table'}
        },
        {
          path: '/activitySys/activityEntrance',
          name: 'activityEntrance',
          component: () => import('@/views/activitySys/activityEntrance/index'),
          meta: { title: '活动入口管理', icon: 'table'}
        },
        {
          path: '/activitySys/activityShareList',
          name: 'activityShareList',
          component: () => import('@/views/activitySys/activityShareList/index'),
          meta: { title: '分享邀请用户明细', icon: 'table'}
        },
        {
          path: '/activitySys/activitySignInList',
          name: 'activityShareList',
          component: () => import('@/views/activitySys/activitySignInList/index'),
          meta: { title: '签到用户明细', icon: 'table'}
        },
        {
          path: '/activitySys/noviceActivityList',
          name: 'noviceActivityList',
          component: () => import('@/views/activitySys/noviceActivityList'),
          meta: { title: '新手活动', icon: 'table'}
        },
        {
          path: '/activitySys/noviceDataAnalysis',
          name: 'noviceDataAnalysis',
          component: () => import('@/views/activitySys/noviceDataAnalysis'),
          meta: { title: '数据分析', icon: 'table'}
        },
        {
          path: '/activitySys/noviceActivityDataList',
          name: 'noviceActivityDataList',
          component: () => import('@/views/activitySys/noviceActivityDataList'),
          meta: { title: '活动记录明细', icon: 'table'}
        }
        
        
      ]
    },
    {//意见反馈
      path: '/feedback/feedback',
      name: 'Feedback',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/feedback/feedback',
          name: 'Feedback',
          component: () => import('@/views/feedback/feedback/index'),
          meta: { title: '意见反馈', icon: 'table' }
        }
      ]
    },
    {//创客-任务管理
        path: '/makertask/taskmanage',
        name: 'Taskmanage',
        meta:{requireAuth:true},
        component: Layout,
        children: [
          {
            path: '/makertask/taskmanage',
            name: 'Taskmanage',
            component: () => import('@/views/makertask/taskmanage/index'),
            meta: { title: '任务管理', icon: 'table',keepAlive:true }
          }
        ]
    },
    ,
    {//创客-报名管理
        path: '/registration/index',
        name: 'Registration',
        meta:{requireAuth:true},
        component: Layout,
        children: [
          {
            path: '/registration/index',
            name: 'Taskmanage',
            component: () => import('@/views/registration/index'),
            meta: { title: '报名管理', icon: 'table',keepAlive: true }
          }
        ]
    },
        //个人账户体系
        {
          path: '/personalAccount/balance',
          name: 'personalaccount',
          component: Layout,
          meta:{requireAuth:true},
          children: [
            {
              path: '/personalAccount/balance',
              name: 'balance',
              component: () => import('@/views/personalAccount/balance/index'),
              meta: { title: '余额账户', icon: 'table' }
            },
            {
              path: '/personalAccount/ledou',
              name: 'ledou',
              component: () => import('@/views/personalAccount/ledou/index'),
              meta: { title: '乐豆账户', icon: 'table' }
            },
            {
              path: '/personalAccount/enterpriseAccountSystem',
              name: 'enterpriseAccountSystem',
              component: () => import('@/views/personalAccount/enterpriseAccountSystem'),
              meta: { title: '创客虚拟账户', icon: 'table' }
            },
            {
              path: '/points/growUpSys',
              name: 'points',
              component: () => import('@/views/points/growUpSys/index'),
              meta: { title: '乐豆任务管理', icon: 'table' }
            },
            {
              path: '/points/applyExchange',
              name: 'applyExchange',
              component: () => import('@/views/points/applyExchange/index'),
              meta: { title: '乐豆申请兑换表', icon: 'table' }
            },
            {
              path: '/points/vipList',
              name: 'vipList',
              component: () => import('@/views/points/vipList/index'),
              meta: { title: '会员列表', icon: 'table' }
            },
            {
              path: '/points/vipGrowUpList',
              name: 'vipGrowUpList',
              component: () => import('@/views/points/vipGrowUpList/index'),
              meta: { title: '会员成长值明细', icon: 'table' }
            },
            {
              path: '/points/growUpTaskSys',
              name: 'growUpTaskSys',
              component: () => import('@/views/points/growUpTaskSys/index'),
              meta: { title: '成长值任务管理', icon: 'table' }
            }
            
            
          ]
        },
    // 结算资金管理
    {
      path: '/business/settlementFunds',
      name: 'settlementFunds',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/business/settlementFunds',
          name: 'balance',
          component: () => import('@/views/business/settlementFunds/index'),
          meta: { title: '结算资金管理查看', icon: 'table' }
        }
      ]
    },{
      path: '/message/index',
      name: 'messageIndex',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/message/index',
          name: 'messageIndex',
          component: () => import('@/views/message/index'),
          meta: { title: '消息通知', icon: 'table' }
        }
      ]
    },
    {
      path: '/info/backup',
      name: 'Info',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/info/backup',
          name: 'Backup',
          component: () => import('@/views/info/backup/index'),
          meta: { title: '备份管理', icon: 'table' }
        },{
          path: '/info/taskType',
          name: 'TaskType',
          component: () => import('@/views/info/taskType/index'),
          meta: { title: '任务类型', icon: 'table' }
        },{
          path: '/info/menualImport',
          name: 'MenualImport',
          component: () => import('@/views/info/menualImport/index'),
          meta: { title: '任务手工导入', icon: 'table' }
        }
      ]
    },{
      path: '/maintain/maker',
      name: 'Maintain',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/maintain/maker',
          name: 'Maker',
          component: () => import('@/views/maintain/maker/index'),
          meta: { title: '创客管理', icon: 'table' }
        }, {
          path: '/maintain/allmaker',
          name: 'Maker',
          component: () => import('@/views/maintain/maker/copyIndex'),
          // meta: { title: '创客管理(内)', icon: 'table' }
          meta: { title: '创客管理', icon: 'table' }

        },
        {
          path: '/maintain/registeredusers',
          name: 'Maker',
          component: () => import('@/views/maintain/maker/registeredUsers'),
          meta: { title: '注册用户管理', icon: 'table',keepAlive:true }

        },
        {
          path: '/maintain/yunyingmaker',
          name: 'Maker',
          component: () => import('@/views/maintain/maker/lianyingIndex'),
          // meta: { title: '创客管理-运营', icon: 'table' }
          meta: { title: '创客管理', icon: 'table' }

        },{
          path: '/maintain/settleIn',
          name: 'Maker',
          component: () => import('@/views/maintain/settleIn/index'),
          meta: { title: '企业入驻申请', icon: 'table' }

        },
        {
          path: '/maintain/land',
          name: 'Land',
          component: () => import('@/views/maintain/land/index'),
          meta: { title: '供应商管理', icon: 'table' }
        },{
          path: '/maintain/enterprise',
          name: 'Enterprise',
          component: () => import('@/views/maintain/enterprise/index'),
          meta: { title: '企业管理', icon: 'table' }
        },{
          path: '/maintain/enterprisePlatfrom',
          name: 'Enterprise',
          component: () => import('@/views/maintain/enterprisePlatfrom/index'),
          // meta: { title: '企业管理(平台)', icon: 'table' }
          meta: { title: '企业管理', icon: 'table' }
        },{
          path: '/maintain/registerEnterprise',
          name: 'registerEnterprise',
          component: () => import('@/views/maintain/registerEnterprise/index'),
          // meta: { title: '企业管理(平台)', icon: 'table' }
          meta: { title: '注册企业管理', icon: 'table',keepAlive: true }
        },{
          path: '/maintain/statistics',
          name: 'Statistics',
          component: () => import('@/views/maintain/statistics/index'),
          meta: { title: '平台概况', icon: 'table' }
        },{
          path: '/maintain/statement',
          name: 'Statement',
          component: () => import('@/views/maintain/statement/index'),
          meta: { title: '企业概况', icon: 'table' }
        },{
          path: '/maintain/category',
          name: 'Category',
          component: () => import('@/views/maintain/category/index'),
          meta: { title: '职位类型', icon: 'table' }
        }
        ,{
          path: '/maintain/lypcategory',
          name: 'Category',
          component: () => import('@/views/maintain/lypcategory/index'),
          meta: { title: '职位类型', icon: 'table' }
        }
      ]
    },{
      path: '/evaluation/evalueOfEnterprise',
      name: 'Evaluation',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/evaluation/evalueOfEnterprise',
          name: 'EvalueOfEnterprise',
          component: () => import('@/views/evaluation/evalueOfEnterprise/index'),
          meta: { title: '企业评价管理', icon: 'table' }
        },{
          path: '/evaluation/evalueOfPerson',
          name: 'EvalueOfPerson',
          component: () => import('@/views/evaluation/evalueOfPerson/index'),
          meta: { title: '个人评价管理', icon: 'table' }
        }
      ]
    },{
      path: '/labels/labelOfEnterprise',
      name: 'Labels',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/labels/labelOfEnterprise',
          name: 'LabelOfEnterprise',
          component: () => import('@/views/labels/labelOfEnterprise/index'),
          meta: { title: '企业标签管理', icon: 'table' }
        },{
          path: '/labels/labelOfPerson',
          name: 'LabelOfPerson',
          component: () => import('@/views/labels/labelOfPerson/index'),
          meta: { title: '个人标签管理', icon: 'table' }
        },{
          path: '/labels/labelsManage',
          name: 'LabelsManage',
          component: () => import('@/views/labels/labelsManage/index'),
          meta: { title: '标签管理', icon: 'table' }
        }
      ]
    },{
      path: '/integral/integralDetails',
      name: 'Integral',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/integral/integralDetails',
          name: 'IntegralDetails',
          component: () => import('@/views/integral/integralDetails/index'),
          meta: { title: '积分明细管理', icon: 'table' }
        },{
          path: '/integral/integralTasks',
          name: 'IntegralTasks',
          component: () => import('@/views/integral/integralTasks/index'),
          meta: { title: '积分任务管理', icon: 'table' }
        }
      ]
    },{
      path: '/settlementFunds/fundManagement',
      name: 'FundManagement',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/settlementFunds/fundManagement',
          name: 'FundManagement',
          component: () => import('@/views/settlementFunds/fundManagement/index'),
          meta: { title: '资金管理查看', icon: 'table' }
        }
      ]
    },{
      path: '/authority/user',
      name: 'Authority',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/authority/user',
          name: 'User',
          component: () => import('@/views/authority/user/index'),
          meta: { title: '用户管理', icon: 'table',keepAlive:true }
        },{
          path: '/authority/role',
          name: 'Role',
          component: () => import('@/views/authority/role/index'),
          meta: { title: '角色管理', icon: 'table' }
        },{
          path: '/authority/duty',
          name: 'Duty',
          component: () => import('@/views/authority/duty/index'),
          meta: { title: '职责管理', icon: 'table' }
        },{
          path: '/authority/menu',
          name: 'Menu',
          component: () => import('@/views/authority/menu/index'),
          meta: { title: '菜单管理', icon: 'table' }
        }
      ]
    },{
      path: '/invoiceInside/apply',
      name: 'invoiceInside',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/invoiceInside/apply',
          name: 'ApplyList',
          component: () => import('@/views/invoiceInside/apply/list'),
          meta: { title: '内部发票列表', icon: 'table' }
        },
        {
          path: '/invoiceInside/applyindex',
          name: 'ApplyIndex',
          component: () => import('@/views/invoiceInside/apply/apply'),
          meta: { title: '内部发票申请', icon: 'table' }
        },
        {
          path: '/invoiceInside/receiver',
          name: 'Receiver',
          component: () => import('@/views/invoiceInside/receiver/index'),
          meta: { title: '内部发票实开', icon: 'table' }
        },
        {
          path: '/invoiceInside/record',
          name: 'Record',
          component: () => import('@/views/invoiceInside/record/index'),
          meta: { title: '内部发票实开记录', icon: 'table' }
        },
        {
          path: '/invoiceInside/expressage',
          name: 'Expressage',
          component: () => import('@/views/invoiceInside/expressage/index'),
          meta: { title: '内部发票信息完善', icon: 'table' }
        }
      ]
    },{
      path: '/invoice/subject',
      name: 'Subjsect',
      meta:{requireAuth:true},
      component: Layout,
      children: [

        {
          path: '/invoice/subject',
          name: 'Subjsect',
          component: () => import('@/views/invoice/subject/index'),
          meta: { title: '发票科目', icon: 'table' }
        },
        {
          path: '/invoice/subjectMessage',
          name: 'Message',
          component: () => import('@/views/invoice/subjectMessage/index'),
          meta: { title: '发票科目信息', icon: 'table' }
        },{
          path: '/invoice/applyList',
          name: 'ApplyList',
          component: () => import('@/views/invoice/apply/list'),
          meta: { title: '发票列表', icon: 'table' }
        },{
          path: '/invoice/apply',
          name: 'Apply',
          component: () => import('@/views/invoice/apply/index'),
          meta: { title: '发票申请', icon: 'table' }
        },{
          path: '/invoice/lypapplyList',
          name: 'lypapplyList',
          component: () => import('@/views/invoice/lypapply/list'),
          meta: { title: '发票列表', icon: 'table' }
        },{
          path: '/invoice/lypapply',
          name: 'lypapply',
          component: () => import('@/views/invoice/lypapply/index'),
          meta: { title: '发票申请', icon: 'table' }
        },{
          path: '/invoice/deal',
          name: 'Deal',
          component: () => import('@/views/invoice/deal/index'),
          meta: { title: '发票批处理', icon: 'table' }
        },{
          path: '/invoice/history',
          name: 'History',
          component: () => import('@/views/invoice/history/index'),
          meta: { title: '历史批处理', icon: 'table' }
        },{
          path: '/invoice/receiver',
          name: 'Receiver',
          component: () => import('@/views/invoice/receiver/index'),
          meta: { title: '收款方发票实开', icon: 'table' }
        },{
          path: '/invoice/record',
          name: 'Record',
          component: () => import('@/views/invoice/record/index'),
          meta: { title: '发票实开记录', icon: 'table' }
        },{
          path: '/invoice/recordAuarantine',
          name: 'RecordAuarantine',
          component: () => import('@/views/invoice/recordAuarantine'),
          // meta: { title: '发票实开记录(隔离)', icon: 'table' }
          meta: { title: '发票实开记录', icon: 'table' }
        },{
          path: '/invoice/expressage',
          name: 'Expressage',
          component: () => import('@/views/invoice/expressage/index'),
          meta: { title: '发票快递信息完善', icon: 'table' }
        }
      ]
    },{
      path: '/workflow/process',
      name: 'Workflow',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/workflow/process',
          name: 'Process',
          component: () => import('@/views/workflow/processDefinition/index'),
          meta: { title: '流程定义', icon: 'table' }
        },{
          path: '/workflow/notification',
          name: 'Notification',
          component: () => import('@/views/workflow/processNotification/index'),
          meta: { title: '流程通知', icon: 'table' }
        }
      ]
    },{
      path: '/agent/enterprise',
      name: 'Agent',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/agent/enterprise',
          name: 'AgentEnterprise',
          component: () => import('@/views/agent/enterprise/index'),
          // meta: { title: '代理企业', icon: 'table' }
          meta: { title: '企业管理', icon: 'table' }
        }
      ]
    },{
      path: '/news/newsManage',
      name: 'News',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/news/newsManage',
          name: 'NewsManage',
          component: () => import('@/views/news/newsManage/index'),
          meta: { title: '消息列表', icon: 'table' }
        },{
          path: '/news/newsSend',
          name: 'NewsSend',
          component: () => import('@/views/news/newsSend/index'),
          meta: { title: '消息群发', icon: 'table' }
        }
      ]
    },{
      path: '/platform/list',
      name: 'Platform',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/platform/list',
          name: 'PlatformList',
          component: () => import('@/views/platform/list/index'),
          meta: { title: '平台列表', icon: 'table' }
        }
      ]
    },{//用户中心
      path: '/usercenter',
      name: 'usercenter',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/usercenter/organization',
          name: 'Organization',
          component: () => import('@/views/usercenter/organization'),
          meta: { title: '组织机构', icon: 'table' }
        }
      ]
    },{//合同管理
      path: '/contracts',
      name: 'contracts',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/contracts/contractType',
          name: 'contracttype',
          component: () => import('@/views/contracts/contractType'),
          meta: { title: '合同类型', icon: 'table' }
        },
        {
          path: '/contracts/contractsSet',
          name: 'contractsset',
          component: () => import('@/views/contracts/contractsSet'),
          meta: { title: '合同设置', icon: 'table' }
        },
        {
          path: '/contracts/hiringPointSet',
          name: 'hiringPointSet',
          component: () => import('@/views/contracts/hiringPointSet'),
          meta: { title: '聘点设置', icon: 'table' }
        },
        {
          path: '/contracts',
          name: 'contracts',
          component: () => import('@/views/contracts'),
          meta: { title: '合同管理', icon: 'table' }
        },
        {
          path: '/contracts/contractsQuotation',
          name: 'contractsQuotation',
          component: () => import('@/views/contracts/contractsQuotation'),
          meta: { title: '合同报价单', icon: 'table' }
        }
      ]
    },{//产品管理
      path: '/product',
      name: 'product',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/product/production',
          name: 'Product',
          component: () => import('@/views/product/production'),
          meta: { title: '产品管理', icon: 'table' }
        },
        {
          path: '/product/productType',
          name: 'productType',
          component: () => import('@/views/product/productType'),
          meta: { title: '产品类型', icon: 'table' }
        }
      ]
    },
    {//收款管理
      path: '/receivables',
      name: 'receivables',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/receivables/list',
          name: 'List',
          component: () => import('@/views/receivables/list'),
          meta: { title: '收款列表', icon: 'table' }
        },  
        {
          path: '/receivables/verification',
          name: 'verification',
          component: () => import('@/views/receivables/verification'),
          meta: { title: '核销管理', icon: 'table' }
        },
        {
          path: '/receivables/capital',
          name: 'Capital',
          component: () => import('@/views/receivables/capital'),
          meta: { title: '资金管理', icon: 'table' }
        },
      ]
    },
    // 投保人员管理
    {
      path: '/insurancePeople',
      name: 'insurancePeople',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/insurancePeople',
          name: 'InsurancePeople',
          component: () => import('@/views/business/insurancepeople'),
          meta: { title: '投保人员管理', icon: 'table' }
        }
      ]
    },
    //财务对账
    {
      path: '/financeAccounts',
      name: 'financeAccounts',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/financeAccounts/fund',
          name: 'Fund',
          component: () => import('@/views/financeAccounts/fund'),
          meta: { title: '财务资金管理', icon: 'table' }
        },
        {
          path: '/financeAccounts/verification',
          name: 'verification',
          component: () => import('@/views/financeAccounts/verification'),
          meta: { title: '财务核销管理', icon: 'table' }
        }
      ]
    },
     //分销系统
     {
      path: '/distribution',
      name: 'distribution',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/distribution/distributorSetup',
          name: 'DistributorSetup',
          component: () => import('@/views/distribution/distributorSetup'),
          meta: { title: '分销商设置', icon: 'table' }
        },  
        {
          path: '/distribution/distributorAudit',
          name: 'distributorAudit',
          component: () => import('@/views/distribution/distributorAudit'),
          meta: { title: '分销商审核', icon: 'table' }
        },
        {
          path: '/distribution/distributorInformation',
          name: 'distributorInformation',
          component: () => import('@/views/distribution/distributorInformation'),
          meta: { title: '分销商信息', icon: 'table' }
        },
        {
          path: '/distribution/distributorRecord',
          name: 'distributorRecord',
          component: () => import('@/views/distribution/distributorRecord'),
          meta: { title: '分销商佣金记录', icon: 'table' }
        },
        {
          path: '/distribution/withdrawalApply',
          name: 'withdrawalApply',
          component: () => import('@/views/distribution/withdrawalApply'),
          meta: { title: '分销商提现申请', icon: 'table' }
        },
        {
          path: '/distribution/distributorAnalysis',
          name: 'distributorAnalysis',
          component: () => import('@/views/distribution/distributorAnalysis'),
          meta: { title: '分销商数据分析', icon: 'table' }
        },
      ]
    },
    // 在线文档
    {
      path: '/system',
      name: 'fileCenter',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/system/fileCenter',
          name: 'fileCenter',
          component: () => import('@/views/system/fileCenter'),
          meta: { title: '在线文档', icon: 'table' }
        }
      ]
    },
   // 统计分析报表
      {
      path: '/statistics',
      name: 'statistics',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/statistics/reportForm',
          name: 'fileCenter',
          component: () => import('@/views/statistics/index'),
          meta: { title: '统计分析报表', icon: 'table' }
        }
      ]
    },
       // 外包业务
      {
      path: '/outsource',
      name: 'outsource',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/outsource/bill',
          name: 'outsourceBill',
          component: () => import('@/views/outsource/bill'),
          meta: { title: '外包账单', icon: 'table' }
        },
        {
          path: '/outsource/settlementBill',
          name: 'settlementBill',
          component: () => import('@/views/outsource/settlementBill'),
          meta: { title: '结算账单', icon: 'table' }
        }
      ]
    },
    //流量统计管理
    {
      path: '/flowstatistics',
      name: 'flowstatistics',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/flowstatistics/flowadmin',
          name: 'flowstatistics',
          component: () => import('@/views/flowstatistics/flowadmin/index'),
          meta: { title: '新增流量分析', icon: 'table' }
        },{
          path: '/flowstatistics/phoneadmin',
          name: 'flowstatistics',
          component: () => import('@/views/flowstatistics/phoneadmin/index'),
          meta: { title: '电话邀约官工作分析', icon: 'table' }
        }
      ]
    },
    {
      path: '*',
      component: Layout,
      meta: {
          title: '东乐 e 聘'
      }
    },
    {
      path: '/recruit/enterpriseRecruit',
      name: 'Info',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/recruit/enterpriseRecruit',
          name: 'enterpriseRecruit',
          component: () => import('@/views/statisticalAnalysis/recruit/enterpriseRecruit/index'),
          meta: { title: '招聘数据中心', icon: 'table' }
        },{
          path: '/recruit/platformRecruit',
          name: 'platformRecruit',
          component: () => import('@/views/statisticalAnalysis/recruit/platformRecruit/index'),
          meta: { title: '招聘数据中心', icon: 'table' }
        },{
          path: '/user/sourceAnalysis',
          name: 'retentionAnalysis',
          component: () => import('@/views/statisticalAnalysis/user/sourceAnalysis/index'),
          meta: { title: '来源分析', icon: 'table',keepAlive:true }
        },{
          path: '/user/pageAnalysis',
          name: 'pageAnalysis',
          component: () => import('@/views/statisticalAnalysis/user/pageAnalysis/index'),
          meta: { title: '页面分析', icon: 'table',keepAlive:true }
        },{
          path: '/user/behaviorAnalysis',
          name: 'behaviorAnalysis',
          component: () => import('@/views/statisticalAnalysis/user/behaviorAnalysis/index'),
          meta: { title: '行为分析', icon: 'table',keepAlive:true }
        },{
          path: '/user/retentionAnalysis',
          name: 'retentionAnalysis',
          component: () => import('@/views/statisticalAnalysis/user/retentionAnalysis/index'),
          meta: { title: '留存分析', icon: 'table',keepAlive:true }
        },{
          path: '/user/activeAnalysis',
          name: 'activeAnalysis',
          component: () => import('@/views/statisticalAnalysis/user/activeAnalysis/index'),
          meta: { title: '活跃分析', icon: 'table',keepAlive:true }
        }
      ]
    },  
    {
      path: '/recruitSys/recruitIndex',
      name: 'Info',
      meta:{requireAuth:true},
      component: Layout,
      children: [
        {
          path: '/recruitSys/recruitIndex',
          name: 'recruitIndex',
          component: () => import('@/views/recruitSys/recruitIndex/index'),
          meta: { title: '首页', icon: 'table' }
        },
        {
          path: '/recruitSys/positionManagement',
          name: 'positionManagement',
          component: () => import('@/views/recruitSys/positionManagement/index'),
          meta: { title: '职位管理', icon: 'table',keepAlive: true }
        },
        {
          path: '/recruitSys/liveAdmin',
          name: 'liveAdmin',
          component: () => import('@/views/recruitSys/liveAdmin/index'),
          meta: { title: '直播管理', icon: 'table' }
        },
        {
          path: '/recruitSys/dbFromList',
          name: 'dbFromList',
          component: () => import('@/views/recruitSys/dbFromList/index'),
          meta: { title: '培训业务', icon: 'table' }
        },{
          path: '/recruitSys/positionManagements',
          name: 'positionManagements',
          component: () => import('@/views/recruitSys/positionManagements/index'),
          meta: { title: '平台职位管理', icon: 'table',keepAlive: true }
        },
        {
          path: '/recruitSys/signupadmin',
          name: 'signupadmin',
          component: () => import('@/views/recruitSys/signupadmin/index'),
          meta: { title: '报名管理', icon: 'table',keepAlive: true }
        },
        {
          path: '/recruitSys/talentPool',
          name: 'talentPool',
          component: () => import('@/views/recruitSys/talentPool/index'),
          meta: { title: '人才库', icon: 'table' }
        },
        {
          path: '/recruitSys/newAblePerson',
          name: 'newAblePerson',
          component: () => import('@/views/recruitSys/newAblePerson/index'),
          meta: { title: '新能人', icon: 'table' }
        },{
          path: '/recruitSys/subAccountData',
          name: 'subAccountData',
          component: () => import('@/views/recruitSys/subAccountData/index'),
          meta: { title: '子账号数据', icon: 'table'} 
        },{
          path: '/recruitSys/subAccountSys',
          name: 'subAccountSys',
          component: () => import('@/views/recruitSys/subAccountSys/index'),
          meta: { title: '子账号管理', icon: 'table'}
        },{
          path: '/recruitSys/rightsAdjustment',
          name: 'rightsAdjustment',
          component: () => import('@/views/recruitSys/rightsAdjustment/index'),
          meta: { title: '权益调整', icon: 'table'}
        },{
          path: '/recruitSys/enterpriseData',
          name: 'enterpriseData',
          component: () => import('@/views/recruitSys/enterpriseData/index'),
          meta: { title: '企业数据中心', icon: 'table'}
        },{
          path: '/recruitSys/outboundSys',
          name: 'outboundSys',
          component: () => import('@/views/recruitSys/outboundSys/index'),
          meta: { title: '外呼配置', icon: 'table'}
        },{
          path: '/recruitSys/recommendadmin',
          name: 'recommendadmin',
          component: () => import('@/views/recruitSys/recommendadmin/index'),
          meta: { title: '推荐管理', icon: 'table',keepAlive: true }
        },
        ,{
          path: '/recruitSys/selectionadmin',
          name: 'selectionadmin',
          component: () => import('@/views/recruitSys/selectionadmin/index'),
          meta: { title: '精选管理', icon: 'table',keepAlive: true }
        },{
          path: '/buyOnline/interests',
          name: 'interests',
          component: () => import('@/views/buyOnline/interests/index'),
          meta: { title: '我的权益', icon: 'table' }
        },{
          path: '/recruitSys/lypOrder',
          name: 'lypOrder',
          component: () => import('@/views/recruitSys/lypOrder/index'),
          meta: { title: '我的订单', icon: 'table' }
        },{
          path: '/recruitSys/orderManagement',
          name: 'orderManagement',
          component: () => import('@/views/recruitSys/orderManagement/index'),
          meta: { title: '订单管理', icon: 'table',keepAlive:true }
        }
        ,{
          path: '/recruitSys/information',
          name: 'information',
          component: () => import('@/views/recruitSys/information/information'),
          meta: { title: '企业信息', icon: 'table' }
        },{
          path: '/recruitSys/myrights',
          name: 'myrights',
          component: () => import('@/views/recruitSys/myrights/myrights'),
          meta: { title: '我的权益', icon: 'table' }
        },{
          path: '/recruitSys/equityManagement',
          name: 'equityManagement',
          component: () => import('@/views/recruitSys/equityManagement/index'),
          meta: { title: '权益列表', icon: 'table',keepAlive:true }
        }, {
          path: '/recruitSys/personIndex',
          name: 'personIndex',
          component: () => import('@/views/recruitSys/personIndex/index'),
          meta: { title: '个人中心', icon: 'table' }
        },{
          path: '/flowstatistics/lypflowadmin',
          name: 'flowstatistics',
          component: () => import('@/views/flowstatistics/lypflowadmin/index'),
          meta: { title: '新增流量分析', icon: 'table' }
        },{
          path: '/recruitSys/news',
          name: 'recruitSysNews',
          component: () => import('@/views/recruitSys/news/index'),
          meta: { title: '新闻管理', icon: 'table' }
        },
        {
          path: '/recruitSys/payuserAnalysis',
          name: 'payuserAnalysis',
          component: () => import('@/views/recruitSys/payuserAnalysis/index'),
          meta: { title: '付费用户分析', icon: 'table'}
        },
        {
          path: '/recruitSys/postOperation',
          name: 'postOperation',
          component: () => import('@/views/recruitSys/postOperation/index'),
          meta: { title: '职位运营数据管理', icon: 'table'}
        },
        {
          path: '/recruitSys/IntelligentSys',
          name: 'IntelligentSys',
          component: () => import('@/views/recruitSys/IntelligentSys/index'),
          meta: { title: '智能推荐策略定义', icon: 'table'}
        }
      ]
    },
     //报表统计
     {
      path: '/reportStatistics',
      name: 'reportStatistics',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/reportStatistics/BendStatistics',
          name: 'flowstatistics',
          component: () => import('@/views/reportStatistics/BendStatistics/index'),
          meta: { title: 'B端运营数据统计', icon: 'table' }
        },{
          path: '/reportStatistics/RendStatistics',
          name: 'RendStatistics',
          component: () => import('@/views/reportStatistics/RendStatistics/index'),
          meta: { title: 'R端运营数据统计', icon: 'table' }
        }
      ]
    },
    {
      path: '/selfBuitStation',
      name: 'selfBuitStation',
      component: Layout,
      meta:{requireAuth:true},
      children: [
        {
          path: '/selfBuitStation/buildH5',
          name: 'buildH5',
          component: () => import('@/views/selfBuitStation/buildH5/index'),
          meta: { title: '自建站管理', icon: 'table' }
        }
      ]
    },
  ]
})




 router.beforeEach((to, from, next) => {
   if (to.matched.some(res => res.meta.requireAuth)) {// 判断是否需要登录权限
     if (localStorage.getItem('token')) {// 判断是否登录
       next()
     } else {// 没登录则跳转到登录界面  
      Message({
        type: 'error',
        message: '请先登录再访问'
    });
       next({
         path: '/leyeLogin'
       })

     }
   } else {
     next()
   }
 })
export default router